/**
 * @generated SignedSource<<3f31c4749c13d147d19d3d7f37ad80b6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue$data = {
  readonly fieldsById: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fieldId: string;
        readonly " $fragmentSpreads": FragmentRefs<"addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary">;
      } | null | undefined;
    } | null | undefined>;
  };
  readonly summarisedFeatureFlags: {
    readonly totalCount: number | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags" | "singleFlag_softwareReleasesVersionDetailIssueList">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue" | "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue">;
  readonly " $fragmentType": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue";
};
export type featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue$key = {
  readonly " $data"?: featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue$data;
  readonly " $fragmentSpreads": FragmentRefs<"featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "featureFlags_softwareReleasesVersionDetailIssueList_jiraIssue",
  "selections": [
    {
      "concreteType": "DevOpsSummarisedFeatureFlags",
      "kind": "LinkedField",
      "name": "summarisedFeatureFlags",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags"
        },
        {
          "kind": "FragmentSpread",
          "name": "singleFlag_softwareReleasesVersionDetailIssueList"
        },
        {
          "kind": "ScalarField",
          "name": "totalCount"
        }
      ]
    },
    {
      "kind": "RequiredField",
      "field": {
        "args": [
          {
            "kind": "Literal",
            "name": "ids",
            "value": [
              "priority",
              "summary",
              "assignee",
              "status",
              "issuetype"
            ]
          }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueFieldEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "ScalarField",
                        "name": "fieldId"
                      },
                      "action": "THROW",
                      "path": "fieldsById.edges.node.fieldId"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssueSummary"
                        }
                      ],
                      "type": "JiraSingleLineTextField"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "fieldsById.edges"
          }
        ],
        "storageKey": "fieldsById(ids:[\"priority\",\"summary\",\"assignee\",\"status\",\"issuetype\"])"
      },
      "action": "THROW",
      "path": "fieldsById"
    },
    {
      "kind": "FragmentSpread",
      "name": "addFeatureFlag_softwareReleasesVersionDetailIssueList_AddFeatureFlagDropdown_jiraIssue"
    },
    {
      "kind": "FragmentSpread",
      "name": "multipleFlags_softwareReleasesVersionDetailIssueList_jiraIssue"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "bdfcd9de28b80604417e3f543bdb55e1";

export default node;
